import script from "./OrganizationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationPage.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationPage.vue?vue&type=style&index=0&id=1f11e05a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f11e05a"]])

export default __exports__